export default __webpack_public_path__ + "static/media/morgia-logo.35b443fc.png";